import { getGroupedSegments, processGroupedSegments } from '../utils/legacyGeoJSONConversions';
import type { ActivityWithTracks, MapWithRoutes } from '../types/Geo';

const getMapElevationData = (map: Partial<ActivityWithTracks> | Partial<MapWithRoutes>) => {
  const groupedSegments = getGroupedSegments(map);
  const segments = groupedSegments?.map(group => group.segments).flat();

  if (!segments || segments.length < 1) {
    return [];
  }

  const { pointByPointSegmented } = processGroupedSegments(groupedSegments, true);
  return pointByPointSegmented;
};

export default getMapElevationData;
